<div class="banner">
  <h1>{{ 'rewards.nav.products' | translate }}</h1>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
<fgb-balance-bar></fgb-balance-bar>

<div class="container">
  <fgbcl-marketplace-list [isList]="true" [marketplaceItemTypes]="[4]" [productsItemView]="true"></fgbcl-marketplace-list>
</div>
